import { Component } from '@angular/core';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  standalone: false,
  styleUrl: './pricing.component.scss'
})
export class PricingComponent {}
